import { Navigate } from "react-router-dom";
import { useAuth } from '../../services/context/AuthContext'

function PrivateRoute({ children, redirectTo }) {
  const { authToken } = useAuth()
  return authToken ? children : <Navigate to={redirectTo} />
}

export default PrivateRoute
